import {
  validatePresence,
  validateFormat,
} from 'ember-changeset-validations/validators';

export default {
  name: validatePresence({ presence: true }),
  archive_time: [validateFormat({ type: 'string', allowBlank: true })],
};
